import currency from 'currency.js';

function formatCurrencyWithSymbol(value) {
	const result = currency(value, { separator: "", decimal: ",", symbol: "€", formatWithSymbol: true });
	return result.format(true);
}

export {
	formatCurrencyWithSymbol
}